import { observable } from "mobx";

// config with public keys
export const firebaseConfig = {
  apiKey: "AIzaSyAk3Xp0J8ML7ullzAfpSDJrncX5LJMnAY0",
  authDomain: "webtemp-app.firebaseapp.com",
  databaseURL: "https://webtemp-app.firebaseio.com",
  projectId: "webtemp-app",
  storageBucket: "webtemp-app.firebasestorage.app",
  messagingSenderId: "75649817098",
  appId: "1:75649817098:web:26a0b538d68457d7e41df3",
  measurementId: "G-LJ3M1LHFT6",
};

export const publicVapidKey =
  "BEDnu1BK20lWxwwDPHJRK8Jp1v-0vwc0dOzeHTdH2hUI4WOsZ_6PPg8DKceZpYjeNrCFoKCGQTcSp2rfkSaz6cU";

export const fcmToken = observable.box<string | null>(null);
export const fcmTokenInitialized = observable.box<boolean>(false);
